import { useTranslation } from 'react-i18next'
import _ from 'lodash'

import * as UI from '@/components/componentLibrary'
import { SpatialPolicy as Policy } from '@/models/spatialPolicy'

import { HideableField } from './components'
import { EditableFieldProps } from './types'

const MESSAGE_TITLE = 'Message'

export const Messages = ({ policy, ...props }: { policy: Policy }) => {
  const { t } = useTranslation()

  return (
    <HideableField
      hidden={!_.get(policy.messages, 'en-US')}
      titleText={t('policiesLibrary.formMessageTitle', MESSAGE_TITLE)}
      {...props}
    >
      <div>
        <UI.Text styleType="body">{_.get(policy.messages, 'en-US')}</UI.Text>
      </div>
    </HideableField>
  )
}

export const EditableMessages = ({
  editable,
  editPolicy,
  onValidate,
  policy,
  ...props
}: EditableFieldProps) => {
  const { t } = useTranslation()

  return editable ? (
    <HideableField
      editable
      titleText={t('policiesLibrary.formMessageTitle', MESSAGE_TITLE)}
      {...props}
    >
      <UI.TextArea
        error={props.error}
        name="message"
        onBlur={onValidate}
        onChange={(e, { value }) => editPolicy?.(p => p.setMessages({ 'en-US': value }))}
        placeholder={t(
          'policiesLibrary.formMessagePlaceholder',
          'Leave an optional message for riders here...'
        )}
        value={_.get(policy.messages, 'en-US')}
      />
    </HideableField>
  ) : (
    <Messages policy={policy} {...props} />
  )
}
